// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24ho7","location":"Header_location__220Yg"};